/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { ReactElement, useEffect, useState } from 'react';
import { Upload, Tooltip, UploadProps, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
// types
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadRequestOption } from 'rc-upload/lib/interface';
import { UploadFile } from 'antd/lib/upload/interface';
import { FormikErrors } from 'formik';

import { withTheme, ThemeProps, DefaultTheme } from 'styled-components';
import {
    UploadButton as Button,
    Title,
    Container,
    StyledImgCrop,
} from './styles';

import { Avatar } from '../../Layout';
import { toBase64 } from '../../../helpers/utils';

interface IProps extends UploadProps, ThemeProps<DefaultTheme> {
    error?: string;
    label: string;
    files?: Array<any>;
    avatarUrl?: string;
    nameButton?: string;
    roundShape?: boolean;
    cleanError?: (value: boolean) => any;
    setValue: (
        field: string,
        value: UploadFile | null,
        shouldValidate?: boolean | undefined,
    ) => Promise<FormikErrors<any>> | Promise<void>;
    isUploadImage?: boolean;
}

const UploadButton: React.FC<IProps> = ({
    label,
    error,
    setValue,
    name,
    theme,
    avatarUrl,
    nameButton,
    roundShape,
    cleanError,
    files,
    isUploadImage = false,
    ...uploadProps
}) => {
    const [loading, setLoading] = useState(false);
    const [fileBase64, setFileBase64] = useState<null | string>(null);

    const fakeRequest = ({ onSuccess }: UploadRequestOption) => {
        setTimeout(() => {
            if (onSuccess) {
                onSuccess('ok', new XMLHttpRequest());
            }
        }, 0);
    };

    const onChangeFile = async (info: UploadChangeParam) => {
        const file = info.fileList[0];
        if (cleanError) {
            cleanError(false);
        }

        if (file && info.file.status !== 'removed') {
            setValue(name ?? '', file);
        }

        if (info.file.status === 'uploading') {
            setLoading(true);
        }

        if (info.file.status === 'error') {
            message.error('Erro ao carregar a imagem!');
        }

        if (info.file.status === 'done') {
            if (isUploadImage) {
                const base64Current = await toBase64(file);
                setFileBase64(base64Current.base64);
            }
            setLoading(false);

            if (isUploadImage)
                message.success('A imagem foi carregada com sucesso!');
        }
    };

    const onRemoveValue = () => {
        setFileBase64(null);
        setValue(name ?? '', null);
    };

    useEffect(() => {
        if (avatarUrl && !fileBase64) setFileBase64(avatarUrl);
    }, [avatarUrl]);

    let WrapperUpload = (children: ReactElement<Element>) => children;

    if (isUploadImage) {
        // eslint-disable-next-line react/display-name
        WrapperUpload = (children: ReactElement<Element>) => (
            <Container>
                {fileBase64 && (
                    <Avatar
                        file={fileBase64}
                        loading={loading}
                        roundShape={roundShape}
                    />
                )}
                <StyledImgCrop
                    cropShape={`${roundShape ? 'round' : 'rect'}`}
                    rotate
                >
                    <Upload
                        id={name}
                        name={name}
                        maxCount={1}
                        fileList={files}
                        onChange={onChangeFile}
                        onRemove={onRemoveValue}
                        customRequest={fakeRequest}
                        openFileDialogOnClick
                        {...uploadProps}
                    >
                        <Button
                            style={{
                                borderColor: `${
                                    error ? theme.colors.fail : ''
                                }`,
                                color: `${
                                    error
                                        ? theme.colors.fail
                                        : theme.colors.font
                                }`,
                                borderRadius: '8px',
                            }}
                            icon={<UploadOutlined />}
                        >
                            {nameButton || 'Upload'}
                        </Button>
                    </Upload>
                    {children}
                </StyledImgCrop>
            </Container>
        );
    }
    return (
        <Tooltip placement="topLeft" title={error ?? null}>
            <Title>{label}</Title>
            {WrapperUpload(
                <Upload
                    id={name}
                    name={name}
                    maxCount={1}
                    fileList={files}
                    onChange={onChangeFile}
                    onRemove={onRemoveValue}
                    customRequest={fakeRequest}
                    openFileDialogOnClick
                    {...uploadProps}
                >
                    <Button
                        style={{
                            borderColor: `${error ? theme.colors.fail : ''}`,
                            color: `${
                                error ? theme.colors.fail : theme.colors.font
                            }`,
                            borderRadius: '8px',
                        }}
                        icon={<UploadOutlined />}
                    >
                        {nameButton || 'Upload'}
                    </Button>
                </Upload>,
            )}
        </Tooltip>
    );
};

export default withTheme(UploadButton);
